<mat-progress-bar
    class="loading__progress-bar"
    mode="indeterminate"
    *ngIf="loading"
  ></mat-progress-bar>

<p-toast></p-toast>
<h3 class="header-upload pt-3" mat-dialog-title>Upload multiple {{data.type === employeeType.StoreEmployees ? 'Store Employees' : 'Web Admins'}}</h3>
<mat-dialog-content>
    <p class="desciption-upload">
        Upload using our bulk importer—simply download the template below to format your data. Your employees can upload it on the next page!
    </p>
    
    <div class="operator-add-vehicle-upload-field h-8rem"
        *ngIf="employeesXls.length === 0"
        appDnd (fileDropped)="handleXlsChange($event)">
        <div class="operator-add-vehicle-upload-field__btn-block">
            <div class="operator-add-vehicle-upload-field__title mb-3">Drag and drop your .csv here or choose from your computer.</div>
            <div>
                <input style="display: none" type="file" id="browseFile4" (change)="handleXlsChange($event)">
                <label class="browse-btn" for="browseFile4">Browse CSV File</label>
            </div>
        </div>
        <div *ngIf="progressBar > 0" class="mb-8 progress-cont">
            <div class="progress" [ngStyle]="{ width: progressBar + '%' }"></div>
            <span class="mb-2 percent-complete text-very-small">{{progressBar}}% Complete</span>
        </div>
    </div>
    <div class="operator-add-vehicle-result-field"
        *ngIf="employeesXls.length > 0">
        <p class="result-text mt-2">{{totalUploadedEmployeesCount}} total results</p>
        <p class="result-text">Successfully uploaded: {{successUploadedEmployeesCount}} records</p>
        <p class="result-text"><span class="red-text">Failed or has errors:</span> {{errorUploadedEmployeesCount}} records 
            <span class="float-right"><a class="custom-link" mat-flat-button target="_blank" (click)="saveUnuploadedEmployees()"><mat-icon>download</mat-icon>Download</a></span>
        </p>
    </div>
    <p *ngIf="employeesXls.length === 0" class="download-link">Having trouble? <a class="link-btn" target="_blank" (click)="downloadTemplate()">Download template</a></p>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <a mat-flat-button target="_blank" class="cancel-btn" mat-button [mat-dialog-close]="true">Cancel</a>
    <button class="custom-btn" mat-button [mat-dialog-close]="true" color="primary">Next</button>
</mat-dialog-actions>